import React from "react";
import Navbar from "../pages/Navbar";
import "../styles/home.css";

const About = () => {
    return (
        <div className="page-wrapper">
            <Navbar />

            <main className="about-main">
                {/* Left column */}
                <div className="about-section">
                    <div className="krishtech1">
                        <h1>About</h1>
                        <p>
                            We are building innovative solutions for a digital tomorrow as We
                            are Your IT Friend.
                        </p>
                    </div>
                    <div className="services-grid">
                       <div className="service-card">
                        <h3>Our Story</h3>
                        <p>KrishTech Software was founded in 2024 with a vision to provide high-quality software solutions to businesses of all sizes. With a passion for technology and a commitment to excellence, we've been delivering innovative digital solutions since our inception.</p>
                        </div>
                        <div className="service-card">
                        <h3>Our Mission</h3>
                        <p>To empower businesses through innovative technology solutions, exceptional customer service, and continuous innovation. We believe in creating software that makes a real impact on how businesses operate.</p>
                        </div>
                        <div className="service-card">
                        <h3>Our Vision</h3>
                        <p>To be a global leader in software development, recognized for our quality, reliability, and customer-centric approach. We aspire to transform businesses through intelligent technology solutions.</p>
                        </div>
                        </div>

                </div>

                {/* Right column */}
                    <div className="service-card">
                        <h2>Our Core Values</h2>
                        <div class="services-grid">
                            <div class="service-card"><h3>Innovation</h3><p>We constantly explore new technologies and methodologies to provide cutting-edge solutions that keep our clients ahead of the competition.</p></div>
                            <div class="service-card"><h3>Quality</h3><p>Quality is at the heart of everything we do. We maintain the highest standards in code quality, testing, and project delivery.</p></div>
                            <div class="service-card"><h3>Integrity</h3><p>We operate with honesty and transparency, building trust with our clients through ethical practices and reliable service.</p></div>
                            <div class="service-card"><h3>Customer Focus</h3><p>Our clients' success is our success. We work closely with our clients to understand their needs and deliver solutions that exceed expectations.</p></div>
                            <div class="service-card"><h3>Collaboration</h3><p>We believe in the power of teamwork. Our collaborative approach ensures better solutions and stronger partnerships with our clients.</p></div>
                            <div class="service-card"><h3>Continuous Learning</h3><p>In the fast-paced tech industry, we're committed to continuous learning and improvement to stay ahead of industry trends.</p></div>
                        </div>
                </div>

                <section class="service-card">
                    <h2>Our Expertise</h2>

                    <div className="services-grid">
                        <div className="service-card">
                            <div>
                                <h3>Technology Stack</h3>
                                   <ul>
                                    <li><strong class="frontend">Frontend:</strong> React, Vue.js, Angular, HTML5, CSS3</li>
                                    <li><strong class="backend">Backend:</strong> Java, DotNet, Python, Node.js</li>
                                    <li><strong class="mobile">Mobile:</strong> Android, Flutter, React Native, Swift, Kotlin</li>
                                    <li><strong class="databases">Databases:</strong> MySQL, PostgreSQL, MongoDB, Firebase</li>
                                    <li><strong class="cloud">Cloud:</strong> AWS, Azure, Google Cloud Platform</li>
                                    <li><strong class="devops">DevOps:</strong> Docker, Kubernetes, CI/CD</li>
                                </ul>
                            </div>

                        </div>

                        <div className="service-card">
                            <h3>Industries We Serve</h3>
                            <ul>
                                <li>E-commerce & Retail</li>
                                <li>Healthcare & Wellness</li>
                                <li>Finance & Banking</li>
                                <li>Education & Learning</li>
                                <li>Real Estate & Property</li>
                                <li>Logistics & Supply Chain</li>
                                <li>Entertainment & Media</li>
                                <li>Manufacturing & IoT</li>
                            </ul>
                        </div>

                      </div>
                    
                </section>

                <section class="service-card">
                    <h2>Why Partner With Us?</h2>
                    <div class="services-grid">
                        <div class="service-card"><h3>Proven Track Record</h3><p>We have successfully delivered more projects across diverse industries with high client satisfaction rates.</p></div>
                        <div class="service-card"><h3>Dedicated Team</h3><p>Our talented team of developers, designers, and project managers are dedicated to your project's success.</p></div>
                        <div class="service-card"><h3>Agile Approach</h3><p>We use agile methodologies to ensure flexibility, transparency, and rapid delivery of high-quality software.</p></div>
                        <div class="service-card"><h3>Support & Maintenance</h3><p>We provide comprehensive support and maintenance services to ensure your software performs optimally.</p></div>
                        <div class="service-card"><h3>Scalable Solutions</h3><p>Our solutions are built to scale with your business, growing as your needs evolve.</p></div>
                        <div class="service-card"><h3>Cost Effective</h3><p>We deliver high-quality solutions at competitive prices without compromising on quality.</p></div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <div className="text_style">
                    <p>&copy; 2026 KrishTech Software - Your IT Friend. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default About;
